import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTextFormatSize(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M9 4v3h5v12h3V7h5V4H9Zm-6 8h3v7h3v-7h3V9H3v3Z" fill="currentColor" />
    </BaseIcon>
  );
}
